// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductPrice_grey__3kbk\\+ {
  color: grey !important;
}

.ProductPrice_price-line__gL7MJ {
  display: flex;
  justify-content: space-between;
}

.ProductPrice_unit-price__Sowfo {
  align-items: center;
  background-color: #fbfbfb;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
}
.ProductPrice_unit-price__Sowfo .ProductPrice_price__0J7Mq {
  font-size: 14px;
}

.ProductPrice_price-summary__3PcsB {
  margin-top: 12px;
}
.ProductPrice_price-summary__3PcsB .ProductPrice_total-price__nGO3c {
  align-items: start;
  font-size: 16px;
  font-weight: bold;
}
.ProductPrice_price-summary__3PcsB .ProductPrice_total-price__nGO3c .ProductPrice_total__xnID1 {
  font-size: 28px;
}
.ProductPrice_price-summary__3PcsB .ProductPrice_info__Ndor- {
  text-align: right;
  font-size: 14px;
  line-height: 22px;
}
.ProductPrice_price-summary__3PcsB .ProductPrice_info__Ndor- .ProductPrice_green__7k46l {
  color: #4ba564;
}

.ProductPrice_button__woB6M Button {
  margin-top: 16px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/ProductPrice/ProductPrice.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,sBAAA;AAFF;;AAIA;EACE,aAAA;EACA,8BAAA;AADF;;AAIA;EACE,mBAAA;EACA,yBCDsB;EDEtB,kBAAA;EACA,eAAA;EACA,iBETK;EFUL,iBAAA;AADF;AAEE;EACE,eElBK;AFkBT;;AAIA;EACE,gBAAA;AADF;AAEE;EACE,kBAAA;EACA,eAAA;EACA,iBErBG;AFqBP;AACI;EACE,eAAA;AACN;AAGE;EACE,iBAAA;EACA,eEnCK;EFoCL,iBAAA;AADJ;AAEI;EACE,cCXQ;ADWd;;AAKE;EACE,gBAAA;EACA,WAAA;AAFJ","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.grey {\n  color: grey !important;\n}\n.price-line {\n  display: flex;\n  justify-content: space-between;\n}\n\n.unit-price {\n  align-items: center;\n  background-color: colors.$color-background-text;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: typography.$bold;\n  line-height: 20px;\n  .price {\n    font-size: typography.$body-m;\n  }\n}\n\n.price-summary {\n  margin-top: 12px;\n  .total-price {\n    align-items: start;\n    font-size: 16px;\n    font-weight: typography.$bold;\n    .total {\n      font-size: 28px;\n    }\n  }\n\n  .info {\n    text-align: right;\n    font-size: typography.$body-m;\n    line-height: 22px;\n    .green {\n      color: colors.$success-300;\n    }\n  }\n}\n.button {\n  Button {\n    margin-top: 16px;\n    width: 100%;\n  }\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grey": `ProductPrice_grey__3kbk+`,
	"price-line": `ProductPrice_price-line__gL7MJ`,
	"unit-price": `ProductPrice_unit-price__Sowfo`,
	"price": `ProductPrice_price__0J7Mq`,
	"price-summary": `ProductPrice_price-summary__3PcsB`,
	"total-price": `ProductPrice_total-price__nGO3c`,
	"total": `ProductPrice_total__xnID1`,
	"info": `ProductPrice_info__Ndor-`,
	"green": `ProductPrice_green__7k46l`,
	"button": `ProductPrice_button__woB6M`
};
export default ___CSS_LOADER_EXPORT___;
